import clsx from 'clsx';

import { SearchBar } from './search/SearchBar';
import { List } from './List';
import { Stage } from './Stage';
import styles from '../styles/IconLibrary.module.css';

export const Page = () => {
  return (
    <div
      className={clsx(
        styles.container,
        'icon-library--container',
        `flex flex-col min-h-full h-full text-xs overflow-hidden relative w-full leading-normal`,
      )}
    >
      <div className={`flex flex-col h-full relative w-full border-darkgray border-solid border bg-gray`}>
        <SearchBar />
        <List />
        <Stage />
      </div>
    </div>
  );
};
